<div class="flex-container">
  <div class="flex-item no-grow">
    <div>
      <button style="margin-bottom: 2px; font-size: smaller" (click)="createGameTable()">新しいテーブルを作る</button>
    </div>
    <select style="width: 100%; max-width: 155px" size="10" (change)="selectGameTable($event.target.value)" [ngModel]="selectedTable?.identifier">
      <option *ngFor="let gameTable of getGameTables()" value="{{gameTable.identifier}}">{{gameTable.name}}</option>
    </select>
  </div>
  <div class="flex-item">
    <div style="float: right; margin-top: 3px; margin-right: 3px">
      <label sytle="white-space: nowrap">
        <input name="show-hide-images" type="checkbox" value="Show Hides" checked="{{isShowHideImages ? 'checked' : ''}}" (click)="onShowHiddenImages($event)">
        <i class="material-icons" style="font-size: smaller" [ngClass]="{'red-eye': isShowHideImages}">{{ isShowHideImages ? 'visibility' : 'visibility_off' }}</i>
      </label>
    </div>
    <ng-container *ngIf="!isEmpty || selectedTable">
      <div class="images-select">
        <div>
          画像
          <div (click)="openBgImageModal()" style="position: relative; overflow: hidden">
            <div *ngIf="getHidden(tableBackgroundImage)" style="position: absolute; text-align: right; top: 0px; right: 0px; pointer-events: none; z-index: 5">
              <i class="material-icons" [class]="isShowHideImages ? 'red-eye': 'grow'" style="margin-right: 2px; font-size: 16px; display: block">{{ isShowHideImages ? 'visibility' : 'visibility_off' }}</i>
            </div>
            <img height="120" [ngClass]="{ blackout: !isShowHideImages && getHidden(tableBackgroundImage) }" [src]="tableBackgroundImage.url | safe: 'resourceUrl'">
          </div>
        </div>
        <div>
          背景
          <div *ngIf="!tableDistanceviewImage.url">
            <button (click)="openDistanceViewImageModal()" style="height: 120px;" [attr.disabled]="!isEditable ? '' : null">背景画像を追加</button>
          </div>
          <div *ngIf="tableDistanceviewImage.url" style="position: relative; overflow: hidden" (click)="openDistanceViewImageModal()">
            <div *ngIf="getHidden(tableDistanceviewImage)" style="position: absolute; text-align: right; top: 0px; right: 0px; pointer-events: none; z-index: 5">
              <i class="material-icons" [class]="isShowHideImages ? 'red-eye': 'grow'" style="margin-right: 2px; font-size: 16px; display: block">{{ isShowHideImages ? 'visibility' : 'visibility_off' }}</i>
            </div>
            <img height="120" [ngClass]="{ blackout: !isShowHideImages && getHidden(tableDistanceviewImage) }" [src]="tableDistanceviewImage.url | safe: 'resourceUrl'">
          </div>
        </div>
      </div>
      <div>Name :
        <input [(ngModel)]="tableName" placeholder="Name" [attr.disabled]="!isEditable ? '' : null" />
      </div>
      <div>
        <input [(ngModel)]="tableWidth" type="range" title="{{tableWidth}}" min="{{minSize}}" max="{{maxSize}}" name="tableWidth" [attr.disabled]="!isEditable ? '' : null"
        /> Width :
        <input [(ngModel)]="tableWidth" type="number" min="{{minSize}}" max="{{maxSize}}" style="width: 5em;" [attr.disabled]="!isEditable ? '' : null">
      </div>
      <div>
        <input [(ngModel)]="tableHeight" title="{{tableHeight}}" type="range" min="{{minSize}}" max="{{maxSize}}" name="tableHeight" [attr.disabled]="!isEditable ? '' : null"
        /> Height :
        <input [(ngModel)]="tableHeight" type="number" min="{{minSize}}" max="{{maxSize}}" style="width: 5em;" [attr.disabled]="!isEditable ? '' : null">
      </div>
      <div>
        グリッド:
        <select [(ngModel)]="tableGridType" name="tableGridType" [attr.disabled]="!isEditable ? '' : null">
          <option value="-1">なし</option>
          <option value="0">スクエア</option>
          <option value="1">ヘクス（縦揃え）</option>
          <option value="2">ヘクス（横揃え）</option>
        </select>
        色:
        <select [(ngModel)]="tableGridColor" name="tableGridColor" [attr.disabled]="!isEditable ? '' : null">
          <option value="#000000e6">黒</option>
          <option value="#dddddde6">白</option>
        </select>
      </div>
      <div>
        背景フィルタ
        <select [(ngModel)]="tableDistanceviewFilter" name="tableDistanceviewFilter" [attr.disabled]="!isEditable ? '' : null">
          <option value="">なし</option>
          <option value="white">ホワイト</option>
          <option value="black">ブラック</option>
        </select>
      </div>
      <hr/>
      <div>
        <label class="self-setting">
          <input type="checkbox" [(ngModel)]="tableGridShow" name="tableGridShow" />
          グリッドを常に表示<sup class="self-only">*</sup>
        </label>
        <label style="margin-left: 1em" class="self-setting">
          <input type="checkbox" [(ngModel)]="tableGridSnap" name="tableGridSnap" />
          スナップ<sup class="self-only">*</sup>
        </label>
        <ng-container *ngIf="!isDeleted">
          <button style="margin-left: 2em" [disabled]="isSaveing" (click)="save()">
            <div style="position: relative;">
              <div [ngClass]="{'is-hidden': isSaveing}">保存</div>
              <div *ngIf="isSaveing" class="progress">{{progresPercent}}%</div>
            </div>
          </button>
          <button class="danger" (click)="delete()" [attr.disabled]="getGameTables().length <= 1 ? '' : null">削除</button>
        </ng-container>
        <ng-container *ngIf="isDeleted">
          <button (click)="restore()">元に戻す</button>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="isEmpty">
  <div style="font-size: 12px;">※テーブルが１つも作成されていません。「新しいテーブルを作る」から新しいテーブルを作成することができます。</div>
</ng-container>
